import { render, staticRenderFns } from "./TestPage.vue?vue&type=template&id=4d10695f&"
import script from "./TestPage.vue?vue&type=script&lang=ts&"
export * from "./TestPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports